import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex-ter" }
const _hoisted_2 = { style: {"font-weight":"500","margin-right":"4px","color":"rgba(0, 0, 0, .88)","font-size":"14px"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"32px"},
  src: "https://static-jp.theckb.com/static-asset/choice/new_icon.png",
  alt: ""
}, null, -1)
const _hoisted_4 = { style: {"font-size":"12px","line-height":"22px","color":"#000000A6","margin-top":"-6px"} }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { class: "header" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"24px","margin-right":"8px"},
  src: "https://static-s.theckb.com/BusinessMarket/icon/dialog_tip_icon.png",
  alt: ""
}, null, -1)
const _hoisted_11 = { class: "select" }
const _hoisted_12 = {
  key: 2,
  class: "tips"
}
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"8px"} }, [
  /*#__PURE__*/_createTextVNode(" ※ご注意ください：複数倉庫出荷機能を利用すると、ご注文が在庫状況に応じて複数の倉庫から分割発送される場合があります。 "),
  /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"700"} }, " その際、発送ごとに送料が発生するため、単一倉庫からの発送に比べて、合計送料が高くなる可能性があります。 ")
], -1)
const _hoisted_15 = { class: "flex-bwn-ter footer" }
const _hoisted_16 = { class: "flex-ter" }
const _hoisted_17 = { class: "chekbox" }
const _hoisted_18 = ["onClickCapture"]

import { computed, nextTick, ref, reactive } from 'vue'
import { t } from '@/plugins/i18n'
import TermModal from '@/components/termModal/index.vue'
import store, { useSite2Station, isJpPurchase } from '@/store'
import { ShopType, Term } from '@/common/const'
import { getEffectTermByType } from '@/apis/login'
import { ShopPurchaseRespDTO } from '@/service/customer'
import { watch } from '@vue/runtime-core'
import { ElMessage } from 'element-plus'
import { request } from '@/config/request/interceptors'


export default /*#__PURE__*/_defineComponent({
  props: {
    config: { type: null, required: false }
  },
  emits: ['confirm'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  config?: ShopPurchaseRespDTO
}




// 此处的 tiktok，特定 tiktok 店铺不能修改
const isTiktok = computed(() => store.getters?.shopInfo?.customerShopPlatform === ShopType.TIKTOK)
const loading = ref(false)

const wareConfig = reactive({
  allowMutiWareHouseDelivery: false,
  deliveryType: 'ONLY_CN'
})

const beforeChangeFn = () => {
  visible.value = true
  console.log(visible.value, 'visible');
  wareConfig.allowMutiWareHouseDelivery = props.config?.allowMutiWareHouseDelivery ?? false
  wareConfig.deliveryType = props.config?.allowMutiWareHouseDelivery ? (isTiktok.value ? 'ONLY_JP' : 'ONLY_CN') : 'PRIORITY_CN'
}

// 弹窗逻辑
const visible = ref(false)
const agreed = ref(true)
// 协议
const termModalRef = ref()
const term = ref({ fileUrl: '' })

const catTerm = async () => {
  //
  const res = await getEffectTermByType({
    stationCode: useSite2Station(),
    type: Term.mutiWareHouse
  })
  term.value = res.data[0]
  // 等待props更新后，在open
  nextTick(termModalRef.value.open)
}

const agreeCallback = () => {
  agreed.value = true
  termModalRef.value.close()
}

// 确定配置
const sureConfig = async () => {
  if (!props?.config?.allowMutiWareHouseDelivery && !agreed.value) {
    return ElMessage.error(t('请先勾选协议'))
  }
  loading.value = true
  try {
    await request.customer.customer.shopUpdateMutiWareHouseDelivery({
      allowMutiWareHouseDelivery: !props?.config?.allowMutiWareHouseDelivery, deliveryType: wareConfig.deliveryType
    })
    ElMessage.success(t('更新成功'))
    emits('confirm', true)
    visible.value = false
  } catch (error) {

  } finally {
    loading.value = false
  }

}


return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('多仓发货')), 1),
      _createVNode(_component_el_switch, {
        loading: loading.value,
        "model-value": !!__props.config?.allowMutiWareHouseDelivery,
        onClick: beforeChangeFn
      }, null, 8, ["loading", "model-value"]),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      (__props.config?.deliveryType === 'ONLY_CN')
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(t)('当前为仅从中国仓发货')), 1))
        : _createCommentVNode("", true),
      (__props.config?.deliveryType === 'ONLY_JP')
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(t)('当前为仅从日本仓发货')), 1))
        : _createCommentVNode("", true),
      (__props.config?.deliveryType === 'PRIORITY_CN')
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(t)('当前为中国仓库优先发货')), 1))
        : _createCommentVNode("", true),
      (__props.config?.deliveryType === 'PRIORITY_JP')
        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(t)('当前为日本仓库优先发货')), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_dialog, {
      width: 600,
      "model-value": visible.value,
      "destroy-on-close": "",
      draggable: "",
      "custom-class": "MoreWarehouseDialog",
      onClose: _cache[4] || (_cache[4] = ($event: any) => (visible.value = false))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            (!__props.config?.allowMutiWareHouseDelivery)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_el_checkbox, {
                    style: { '--el-color-primary': '#000' },
                    modelValue: agreed.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((agreed).value = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("span", {
                      class: "agreement",
                      onClickCapture: _withModifiers(catTerm, ["stop"])
                    }, _toDisplayString(_unref(t)('多仓发货协议')), 41, _hoisted_18),
                    _createTextVNode(_toDisplayString(_unref(t)('同意开通')), 1)
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_el_space, { wrap: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                round: "",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (visible.value = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                color: "#000",
                type: "primary",
                round: "",
                onClick: sureConfig
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('确认')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("span", null, _toDisplayString(__props.config?.allowMutiWareHouseDelivery ? _unref(t)('关闭多仓发货') : _unref(t)('开启多仓发货')), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          (!__props.config?.allowMutiWareHouseDelivery)
            ? (_openBlock(), _createBlock(_component_el_radio_group, {
                key: 0,
                modelValue: _unref(wareConfig).deliveryType,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(wareConfig).deliveryType) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, { label: "PRIORITY_JP" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('日本仓库优先，不足再取中国仓库存')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, { label: "PRIORITY_CN" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('中国仓库优先，不足再取日本仓库存')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : (_openBlock(), _createBlock(_component_el_radio_group, {
                key: 1,
                modelValue: _unref(wareConfig).deliveryType,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(wareConfig).deliveryType) = $event))
              }, {
                default: _withCtx(() => [
                  (_unref(isTiktok))
                    ? (_openBlock(), _createBlock(_component_el_radio, {
                        key: 0,
                        label: "ONLY_JP"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('仅从日本仓发库存')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_radio, { label: "ONLY_CN" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(isTiktok) ? _unref(t)('仅从中国仓发库存') : _unref(t)('仅从中国仓发库存，库存不足走采购从中国仓发')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])),
          (!__props.config?.allowMutiWareHouseDelivery)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", {
                  innerHTML: _unref(isTiktok) ?
            _unref(t)(`如同一个三方店铺商品关联了多个商品，则会优先取{X}所有关联商品的库存发货，再取{Y}的库存发货，tiktok店铺库存不足不走采购`, {
              X: _unref(wareConfig).deliveryType === 'PRIORITY_JP' ? '日本倉庫' : '中国倉庫',
              Y: _unref(wareConfig).deliveryType === 'PRIORITY_JP' ? '中国倉庫' : '日本倉庫',
            }) :
            _unref(t)(_unref(isJpPurchase)() ? '如同一个三方店铺商品关联了多个商品，则会优先取{X}所有关联商品的库存发货，再取{Y}的库存发货，当库存不足时，我们将根据商品的原产国采购并补货至对应的目的地仓库后再发货。' : '如同一个三方店铺商品关联了多个商品，则会优先取{X}所有关联商品的库存发货，再取{Y}的库存发货，库存不足走中国采购', {
              X: _unref(wareConfig).deliveryType === 'PRIORITY_JP' ? '日本倉庫' : '中国倉庫',
              Y: _unref(wareConfig).deliveryType === 'PRIORITY_JP' ? '中国倉庫' : '日本倉庫',
            })
                }, null, 8, _hoisted_13),
                _hoisted_14
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["model-value"]),
    _createVNode(TermModal, {
      ref: (_value, _refs) => {
        _refs['termModalRef'] = _value
        termModalRef.value = _value
      },
      title: _unref(t)('多仓发货协议'),
      fileUrl: term.value?.fileUrl,
      disableBtn: true,
      timer: true,
      ondisAgree: agreeCallback
    }, null, 8, ["title", "fileUrl"])
  ]))
}
}

})